// Quiz answer filtering logic
// Hides illogical combinations (e.g., baby can't be 65+, child can't celebrate anniversary)

export const FILTER_RULES = {
  // Recipient → Age filtering
  age: (answers) => {
    const recipient = answers.recipient;
    const hiddenOptions = [];

    if (recipient === 'child') {
      // Children can only be 0-17 years old
      hiddenOptions.push('18-24', '25-34', '35-49', '50-64', '65plus');
    } else if (recipient === 'mother' || recipient === 'father') {
      // Parents must be 18+ (hide child ages)
      hiddenOptions.push('0-5', '6-12', '13-17');
    } else if (recipient === 'grandmother' || recipient === 'grandfather') {
      // Grandparents are typically 50+ (hide all younger ages)
      hiddenOptions.push('0-5', '6-12', '13-17', '18-24', '25-34', '35-49');
    }

    return hiddenOptions;
  },

  // Age → Occasion filtering
  occasion: (answers) => {
    const age = answers.age;
    const recipient = answers.recipient;
    const hiddenOptions = [];

    // Age-based filtering
    if (age === '0-5') {
      // Babies/toddlers - hide adult occasions
      hiddenOptions.push('anniversary', 'graduation');
    } else if (age === '6-12') {
      // Children - hide adult occasions
      hiddenOptions.push('anniversary', 'graduation');
    } else if (age === '13-17') {
      // Teenagers - hide anniversary
      hiddenOptions.push('anniversary');
    }

    // Recipient-based filtering (additional)
    if (recipient === 'child') {
      // Children shouldn't have anniversary as an occasion
      hiddenOptions.push('anniversary');
    }

    // Seasonal occasion filtering
    if (age === '0-5' || age === '6-12' || recipient === 'child') {
      hiddenOptions.push('valentines');
    }
    if (recipient && !['mother', 'grandmother'].includes(recipient)) {
      hiddenOptions.push('mothersday', 'israelimothersday');
    }
    if (recipient && !['father', 'grandfather'].includes(recipient)) {
      hiddenOptions.push('fathersday');
    }
    if (recipient && ['father', 'grandfather'].includes(recipient)) {
      hiddenOptions.push('womensday');
    }

    // Remove duplicates
    return [...new Set(hiddenOptions)];
  }
};

// Helper function to check if an option should be hidden
export const shouldHideOption = (questionId, optionValue, currentAnswers) => {
  const filterRule = FILTER_RULES[questionId];
  if (!filterRule) return false;

  const hiddenOptions = filterRule(currentAnswers);
  return hiddenOptions.includes(optionValue);
};

// Helper function to check if current answers are still valid after a change
export const getInvalidAnswers = (currentAnswers) => {
  const invalidAnswers = [];

  // Check each answer to see if it should now be hidden
  Object.keys(currentAnswers).forEach(questionId => {
    const answerValue = currentAnswers[questionId];
    if (shouldHideOption(questionId, answerValue, currentAnswers)) {
      invalidAnswers.push(questionId);
    }
  });

  return invalidAnswers;
};
